<template>
  <div class="wrapper">
    <section>
      <section-title :title="$t('apps.inventory.message.selectwarehouse')"/>
      <div class="form-row">
        <div class="col-5">
          <select
            class="custom-select"
            @change="handleChangeFromWh"
          >
            <option
              v-for="(bin, index) of fromWarehouseLocations"
              :key="index"
              :value="`${bin.wh_id}-${bin.bin_location_id}`"
            >
              {{ bin.text }}
            </option>
          </select>
        </div>
        <div class="col-2 text-center">
          <span style="position: absolute; top: 0px; left: 0; font-size: 11px; width: 100%;">
            {{ $t('apps.inventory.message.transferto') }} <br>
            <i class="fas fa-long-arrow-alt-right"/>
          </span>
        </div>
        <div class="col-5">
          <select
            class="custom-select"
            @change="handleChangeToWh"
          >
            <option
              :value="-1"
              selected
              disabled>{{ $t('placeholder.select') }}</option>
            <option
              v-for="(bin, index) of toWarehouseLocations"
              :key="index"
              :value="`${bin.wh_id}-${bin.bin_location_id}`"
            >
              {{ bin.text }}
            </option>
          </select>
        </div>
      </div>
    </section>
    <template v-if="isSelectedToWarehouse && productsLoaded == false">
      <p class="mb-0 mt-3">
        {{ $t('message.loading') }}
      </p>
    </template>
    <template v-if="productsLoaded == true && isSelectedToWarehouse">
      <section>
        <section-title :title="$t('message.item')"/>
        <div class="row m-0">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="col-12 box mb-3">
            <div class="row">
              <div :class="disabledActions?'col-12':'col-11'">
                <div class="form-row">
                  <div
                    class="col-6">
                    <vue-bootstrap-autocomplete
                      v-model="item.queryProductName"
                      :data="cloneDeep(optionSkus.filter(opt => selectedSkuIds.indexOf(opt.value) === -1))"
                      :serializer="(item) => item.text + ' ' + (item.sku_code || '')"
                      :minMatchingChars="1"
                      :maxMatches="10"
                      :placeholder="$t('placeholder.selectitem')"
                      :loading="item.loading"
                      :disabled="disabledActions"
                      :showCreate="false"
                      :noResultsInfo="item.loaded ? $t('message.notfounddata') : null"
                      @input="($event) => {
                        items[index].loading = true
                        lookupProducts(index, $event)
                      }"
                      @hit="handleSelectProduct(index, $event)"
                      @blur="handleBlurProduct(index, $event)"
                      @inputBlur="handleInputBlurProduct(index, $event)"
                      @keydown="handleKeydownProduct(index, $event)"
                      @keyup="handleKeyupProduct(index, $event)"
                    >
                      <template
                        slot="suggestion"
                        slot-scope="{ data, htmlText }">
                        <div class="d-flex align-items-center">
                          <img
                            :src="productImage(data.value)"
                            style="width: 40px; height: 40px; border-radius: 0.25rem;"
                          >
                          <div class="d-flex flex-column">
                            <span
                              class="ml-4"
                              v-html="data.text"/>
                            <span
                              class="ml-4"
                              style="font-size: 11px;"
                              v-html="data.sku_code"/>
                          </div>
                        </div>
                      </template>
                    </vue-bootstrap-autocomplete>
                    <!-- <selectize-vue
                      v-model="item.sku_id"
                      :settings="{
                        placeholder: $t('placeholder.selectaproduct'),
                        hideSelected: true
                      }"
                      :disabled="disabledActions"
                    >
                      <option
                        v-for="(item, index) in optionSkus"
                        :key="index"
                        :value="item.value"
                      >
                        {{ item.text }}
                      </option>
                    </selectize-vue> -->
                  </div>
                  <div class="col-6">
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ $t('message.quantity') }}</span>
                      </div>
                      <input
                        :disabled="item.sku_id.length == 0"
                        v-model="item.qty"
                        type="text"
                        class="form-control text-right number-only text-select-all"
                        @keypress="numberOnly"
                        @keyup="item.qty = setToValidNumber(item.qty)"
                        @blur="item.qty = setToCustomDigitsNumber(item.qty)"
                      >
                    </div>
                  </div>
                </div>
                <template v-if="item.sku_id.length > 0">
                  <div class="form-row mt-2">
                    <div class="col-6">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text"
                            style="border-radius: 0.25em 0 0 0;">{{ fromCurrentBinLocationName }}</span>
                        </div>
                        <input
                          :disabled="true"
                          :value="getCurrentStockByBinId(item.sku_id, fromWarehouseId, selectedFromBinLocationId)"
                          type="text"
                          class="form-control text-right"
                          style="border-left: 0;border-radius: 0 0.25em 0 0;"
                        >
                      </div>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text"
                            style="border-top: 0px;border-radius: 0 0 0 0.25em;">
                            <i class="fas fa-sync-alt"/>
                          </span>
                        </div>
                        <input
                          :class="getFontColor(getCurrentStockByBinId(item.sku_id, fromWarehouseId, selectedFromBinLocationId), getNewCalcStock('-', getCurrentStockByBinId(item.sku_id, fromWarehouseId, selectedFromBinLocationId), item.qty))"
                          :disabled="true"
                          :value="getCalcString('-', getCurrentStockByBinId(item.sku_id, fromWarehouseId, selectedFromBinLocationId), item.qty)"
                          type="text"
                          class="form-control text-right"
                          style="border-left: 0px; border-top: 0; border-radius: 0 0 0.25em 0;"
                        >
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text"
                            style="border-radius: 0.25em 0 0 0;">{{ toCurrentBinLocationName }}</span>
                        </div>
                        <input
                          :disabled="true"
                          :value="getCurrentStockByBinId(item.sku_id, toWarehouseId, selectedToBinLocationId)"
                          type="text"
                          class="form-control text-right"
                          style="border-left: 0;border-radius: 0 0.25em 0 0;"
                        >
                      </div>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span
                            class="input-group-text"
                            style="border-top: 0px;border-radius: 0 0 0 0.25em;">
                            <i class="fas fa-sync-alt"/>
                          </span>
                        </div>
                        <input
                          :class="getFontColor(getCurrentStockByBinId(item.sku_id, toWarehouseId, selectedToBinLocationId), getNewCalcStock('+', getCurrentStockByBinId(item.sku_id, toWarehouseId, selectedToBinLocationId), item.qty))"
                          :disabled="true"
                          :value="getCalcString('+', getCurrentStockByBinId(item.sku_id, toWarehouseId, selectedToBinLocationId), item.qty)"
                          type="text"
                          class="form-control text-right"
                          style="border-left: 0px; border-top: 0; border-radius: 0 0 0.25em 0;"
                        >
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div
                v-if="!disabledActions"
                class="col-1 pl-0">
                <button
                  type="button"
                  class="btn btn-block h-100"
                  @click="del(index)">
                  <i class="far fa-trash-alt"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section v-if="!disabledActions">
        <button
          class="btn"
          @click="add()">{{ $t('button.addproduct') }}</button>
      </section>
    </template>
  </div>
</template>

<script>
import SelectizeVue from 'vue2-selectize'
import { mapGetters } from 'vuex'
import _, { debounce, cloneDeep } from 'lodash'
import orderAutocompleteInventoryStockControlMixin from '../../../../../mixins/orderAutocompleteInventoryStockControl'

export default {
  mixins: [orderAutocompleteInventoryStockControlMixin],
  components: {
    SelectizeVue,
  },
  props: {
    // if send sku_id to this component
    // that mean user clicked on that item
    // and want to transfer immediately
    // no add more items
    // no remove an item
    sku_id: {
      type: String,
    },
  },
  data () {
    return {
      cloneDeep,
      productsAvailable: [],
      optionSkus: [],
      items: [],
      fromWarehouseId: null,
      toWarehouseId: null,
      productsLoaded: false,
      selectedFromBinLocationId: null,
      selectedToBinLocationId: -1,

      isLookupProductsDisabled: false,
      tempProducts: [],
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      warehouses: 'getWarehouses',
      getWarehouseInfo: 'getWarehouseInfo',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      isAssignedInWarehouse: 'isAssignedInWarehouse',
      stocks: 'getStocks',
      getProductInfoBySkuId: 'getProductInfoBySkuId',
      defaultImages: 'getDefaultImages',
    }),
    // disabled for default sku_id
    disabledActions () {
      return this.sku_id != null
    },
    filterDestinationWarehouses () {
      return this.warehouses.filter(wh => wh.warehouse_id != this.fromWarehouseId)
    },
    // emit out of this component to use this data for api call
    filterItems () {
      var results = []
      if (this.isSelectedToWarehouse) {
        this.items.map(item => {
          if (item.sku_id.length > 0) {
            var dataSet = {
              'sku_id': item.sku_id,
              'quantity': parseFloat(item.qty),
              'stockout': {
                'warehouse_id': this.fromWarehouseId,
                'stock_id': this.getStockId(this.fromWarehouseId, item.sku_id),
                'bin_location_id': this.selectedFromBinLocationId,
              },
              'stockin': {
                'warehouse_id': this.toWarehouseId,
                'stock_id': this.getStockId(this.toWarehouseId, item.sku_id),
                'bin_location_id': this.selectedToBinLocationId,
              },
            }
            results.push(dataSet)
          }
        })
      }
      return results
    },
    selectedSkuIds () {
      var arr = []
      this.items.map(item => {
        if (item.sku_id.length > 0) {
          arr.push(item.sku_id)
        }
      })
      return arr
    },
    defaultBinLocationId() {
      if (this.disabledActions === false) {
        return null
      }
      const stock = this.stocks.find((stock) => (
        stock.sku.sku_id === this.sku_id && stock.warehouse.warehouse_id === this.fromWarehouseId
      ))
      if (!stock) {
        return null
      }
      const stockLocations = stock.stock_locations.filter((stockLocation) => stockLocation.bin_location_id != null)
      return stockLocations.length === 1
        ? stockLocations[0].bin_location_id
        : null
    },
    fromWarehouseLocations() {
      return this.warehouses.reduce((acc, cur) => {
        const wh = cur

        if (wh.warehouse_id === this.fromWarehouseId) {
          const isWhIdExist = acc.find((item) => item.wh_id === wh.warehouse_id)
          if (!isWhIdExist) {
            acc.push({
              text: `${this.getWarehouseNameById(wh.warehouse_id)}`,
              wh_id: wh.warehouse_id,
              bin_location_id: null,
            })
          }

          if (wh.bin_locations.length > 0) {
            wh.bin_locations.forEach((bin) => {
              acc.push({
                text: `${this.getWarehouseNameById(wh.warehouse_id)} - ${bin.code}`,
                wh_id: wh.warehouse_id,
                bin_location_id: bin._id,
              })
            })
          }
        }
        return acc
      }, [])
    },
    fromCurrentBinLocationName () {
      const item = this.fromWarehouseLocations.find((whLocation) => whLocation.bin_location_id === this.selectedFromBinLocationId)
      return item.text
    },
    toWarehouseLocations () {
      const initialValue = []
      const results = this.warehouses.reduce((acc, cur) => {
        const wh = cur

        const isWhIdExist = acc.find((item) => item.wh_id === wh.warehouse_id)
        if (!isWhIdExist) {
          acc.push({
            text: `${this.getWarehouseNameById(wh.warehouse_id)}`,
            wh_id: wh.warehouse_id,
            bin_location_id: null,
          })
        }

        if (wh.bin_locations.length > 0) {
          wh.bin_locations.forEach((bin) => {
            acc.push({
              text: `${this.getWarehouseNameById(wh.warehouse_id)} - ${bin.code}`,
              wh_id: wh.warehouse_id,
              bin_location_id: bin._id,
            })
          })
        }
        return acc
      }, initialValue)
      return [
        // ...this.fromWarehouseLocations,
        ...results,
      ]
    },
    toCurrentBinLocationName () {
      const item = this.toWarehouseLocations.find((whLocation) => whLocation.bin_location_id === this.selectedToBinLocationId)
      return item.text
    },
    isSelectedToWarehouse() {
      return this.selectedToBinLocationId != -1
    },
    notFoundData() {
      if (this.isSelectedToWarehouse) {
        if (this.disabledActions) { // transfer single sku
          const defaultSkuId = this.items[0].sku_id
          const found = this.optionSkus.find((item) => item.value === defaultSkuId)
          if (!found) {
            return true
          }
        } else { // transfer multiple skus
          if (!this.optionSkus.length) {
            return true
          }
        }
      }
      return false
    },
  },
  watch: {
    filterItems () {
      this.$emit('update:data', {
        'items': this.filterItems,
      })
    },
    selectedFromBinLocationId: {
      handler: function() {
        for (const wh of this.warehouses) {
          for (const bin of wh.bin_locations) {
            if (bin._id === this.selectedFromBinLocationId) {
              this.fromWarehouseId = wh.warehouse_id
              break
            }
          }
        }
      },
      immediate: true,
    },
    selectedToBinLocationId: {
      handler: async function() {
        let found = false
        for (const wh of this.warehouses) {
          for (const bin of wh.bin_locations) {
            if (bin._id === this.selectedToBinLocationId) {
              this.toWarehouseId = wh.warehouse_id
              break
            }
          }
        }
        if (this.items.length == 0) {
          this.add(this.sku_id) // add items for default.

          if (this.sku_id) {
            const response = await this.$store.dispatch('getProduct', {
              sku_id: this.sku_id,
            })
            const products = response.data
            this.tempProducts = [
              ...this.tempProducts,
              ...products,
            ]
            const product = products[0]
            this.items[0].queryProductName = this.getProductFullName(product.product_name, product.prices[0].attributes)
            this.items[0].sku_code = product.prices[0].sku_code
          }
        }
        this.productsLoaded = true
        this.showFinish(this.$Progress)
      },
      immediate: true,
    },
    selectedSkuIds () {
      if (this.selectedSkuIds.length == this.optionSkus.length) {
        return // end this line
      }
      this.items.map((item, index) => {
        if (item.sku_id.length == 0) {
          item.options = _.cloneDeep(this.optionSkus.filter(opt => this.selectedSkuIds.indexOf(opt.value) === -1))
        } else {
          // var tempSkuId = _.cloneDeep(item.sku_id)
          // item.options.map((opt, idx) => {
          //   if(this.selectedSkuIds.indexOf(opt.value) > -1 && opt.value != item.sku_id) {
          //     item.options.splice(idx, 1)
          //     setTimeout(()=>{
          //       this.items[index].sku_id = tempSkuId
          //     }, 1)
          //   }
          // })
        }
      })
    },
  },
  created: async function () {
    this.setData()
  },
  methods: {
    setOptionSkus () {
      this.optionSkus = []
      for (let i in this.productsAvailable) {
        let item = this.productsAvailable[i]
        this.optionSkus.push({
          text: item.product_name,
          sku_code: item.sku_code,
          value: item.sku_id,
        })
      }
    },
    setProductsAvailable () {
      this.productsAvailable = []
      for (let i in this.products) {
        let product = this.products[i]
        for (let j in product.prices) {
          let price = product.prices[j]
          const isAssignedInWarehouseFrom = this.isAssignedInWarehouse(price.sku_id, this.fromWarehouseId)
          const isAssignedInWarehouseTo = this.isAssignedInWarehouse(price.sku_id, this.toWarehouseId)
          if (isAssignedInWarehouseFrom && isAssignedInWarehouseTo) {
            this.productsAvailable.push({
              product_name: this.getProductFullName(product.product_name, price.attributes),
              sku_id: price.sku_id,
              price: price.price || 0,
              cost: price.cost || 0,
              unit: product.unit,
              sku_code: price.sku_code,
            })
          }
        }
      }
      this.setOptionSkus()
    },
    add (skuId) {
      this.items.push({
        sku_id: skuId || '',
        qty: this.setToCustomDigitsNumber(0),
        queryProductName: '',
        sku_code: '',
        loading: false,
        loaded: false,
      })
    },
    del (index) {
      this.items.splice(index, 1)
      let that = this
      if (that.items.length == 0) {
        setTimeout(() => {
          that.add()
        }, 100)
      }
    },
    setData () {
      this.fromWarehouseId = this.$route.query.wh_id
    },
    getCurrentStockByBinId (sku_id, whId, binId) {
      try {
        const sku = this.getSkuInfoBySkuId(sku_id, this.tempProducts)
        const stock = sku.stocks.find((stockItem) => stockItem.warehouse_id === whId)
        const stockLocation = stock.stock_locations.find((locationItem) => locationItem.bin_location_id == binId)
        return this.setToCustomDigitsNumber(stockLocation.instock != null ? stockLocation.instock : 0)
      } catch (err) {
        return this.setToCustomDigitsNumber(0)
      }
    },
    getCalcString (operationType, currentStock, qty) {
      var result = parseFloat(currentStock)
      if (operationType == '+') {
        result += parseFloat(qty)
      } else if (operationType == '-') {
        result -= parseFloat(qty)
      }
      return `${this.setToCustomDigitsNumber(result)}`
    },
    getNewCalcStock (operationType, currentStock, qty) {
      var result = parseFloat(currentStock)
      if (operationType == '+') {
        result += parseFloat(qty)
      } else if (operationType == '-') {
        result -= parseFloat(qty)
      }
      return result
    },
    getFontColor (curentStock, newStock) {
      curentStock = parseFloat(curentStock)
      newStock = parseFloat(newStock)
      if (curentStock == newStock) {
        return ''
      } else if (newStock > curentStock) {
        return 'text-success'
      } else {
        return 'text-danger'
      }
    },
    getStockId (whId, skuId) {
      var sku = this.getSkuInfoBySkuId(skuId, this.tempProducts)
      if (sku) {
        return sku.stocks.find(stock => stock.warehouse_id == whId).stock_id
      }
      return null
    },
    getWarehouseNameById(whId) {
      return this.getWarehouseInfo(whId).warehouse_name
    },
    handleChangeFromWh(event) {
      const arr = event.target.value.split('-')
      const whId = arr[0]
      const binId = arr[1] == 'null' ? null : arr[1]
      this.fromWarehouseId = whId
      this.selectedFromBinLocationId = binId
    },
    handleChangeToWh(event) {
      const arr = event.target.value.split('-')
      const whId = arr[0]
      const binId = arr[1] == 'null' ? null : arr[1]
      this.toWarehouseId = whId
      this.selectedToBinLocationId = binId
    },
  },
}
</script>

<style scoped>
  .wrapper section:last-of-type {
    margin-bottom: 0;
  }
  .box {
    padding: 15px;
    background: #F5F5F5;
  }
  .box:last-of-type {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/stockcontrol/include/ModalTransfer.vue